module.exports = __webpack_public_path__ + "static/media/steam_white.031af093.png";